import { CHECK_SECURITY_CLEARANCE_SERVICE } from "@pages/check-security-clearance/constants";
import type { SecurityClearanceStatusCheckResponse } from "@pages/check-security-clearance/utils/securityClearanceCheckStatus";
import { checkPublicPassportOrEmiratesId } from "@services/securityClearanceApi";
import { useMutation } from "@tanstack/react-query";
import { runInquiry } from "@telemetry/runInquiry";

const PUBLIC_SECURITY_CLEARANCE_CHECK_INQUIRY_CONTEXT = {
  module: "security_clearance",
  screen: "Check Security Clearance",
  action: "check_public_security_clearance_status",
  entityType: "security_clearance",
};

export const useCheckPublicSecurityClearance = () => {
  return useMutation({
    mutationFn: (payload: { id?: string; emiratesId?: string }) =>
      runInquiry(
        PUBLIC_SECURITY_CLEARANCE_CHECK_INQUIRY_CONTEXT,
        () =>
          checkPublicPassportOrEmiratesId({
            service: CHECK_SECURITY_CLEARANCE_SERVICE,
            ...payload,
          }) as Promise<SecurityClearanceStatusCheckResponse>,
      ),
  });
};
